import { render, staticRenderFns } from "./shippingOrders.vue?vue&type=template&id=ebfd2c94"
import script from "./shippingOrders.vue?vue&type=script&lang=js"
export * from "./shippingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports